import { createReducer, createAction } from '@reduxjs/toolkit'

export interface MarketplaceOffer {
  id: string
  model: string
  brand_id: number
  brand_name: string
  vin: string | null
  hash_id: string
  first_registration: string
  total_mileage: number | null
  engine_power: number | null
  number_of_previous_owners: number | null
  thumb_url: string | null
  archived_at: string | null
  published_at: string | null
}

export interface MarketplaceOffersReducer {
  marketplaceOffers: MarketplaceOffer[]
  totalPages: number
  currentPage: number
  totalCount: number
  loading: boolean
  error: boolean
  searchTerm: string
}

const initialState: MarketplaceOffersReducer = {
  marketplaceOffers: [],
  totalPages: 0,
  currentPage: 1,
  totalCount: 0,
  loading: false,
  error: false,
  searchTerm: ''
}

interface FetchMarketplaceOffersSuccessPayload {
  marketplaceOffers: MarketplaceOffer[]
  totalPages: number
  totalCount: number
}

export const FETCH_MARKETPLACE_OFFERS = createAction('marketplace_offers_reducer/fetch_marketplace_offers')
export const FETCH_MARKETPLACE_OFFERS_SUCCESS = createAction<FetchMarketplaceOffersSuccessPayload>(
  'marketplace_offers_reducer/fetch_marketplace_offers_success'
)
export const FETCH_MARKETPLACE_OFFERS_FAILURE = createAction(
  'marketplace_offers_reducer/fetch_marketplace_offers_failure'
)
export const SET_CURRENT_PAGE = createAction<number>('marketplace_offers_reducer/set_current_page')
export const SET_SEARCH_TERM = createAction<string>('marketplace_offers_reducer/set_search_term')

export const marketplaceOffersReducer = createReducer(initialState, (builder) => {
  builder.addCase(FETCH_MARKETPLACE_OFFERS, (state) => {
    return { ...state, loading: true, error: false }
  })
  builder.addCase(FETCH_MARKETPLACE_OFFERS_SUCCESS, (state, action) => {
    return {
      ...state,
      marketplaceOffers: action.payload.marketplaceOffers,
      totalPages: action.payload.totalPages,
      totalCount: action.payload.totalCount,
      loading: false,
      error: false
    }
  })
  builder.addCase(FETCH_MARKETPLACE_OFFERS_FAILURE, (state) => {
    return { ...state, marketplaceOffers: [], loading: false, error: true }
  })
  builder.addCase(SET_CURRENT_PAGE, (state, action) => {
    return { ...state, currentPage: action.payload }
  })
  builder.addCase(SET_SEARCH_TERM, (state, action) => {
    return { ...state, searchTerm: action.payload }
  })
})
